module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogContentSwitcher":{"title":"Nalezeno v","nav":{"articles":"Článcích","faq_questions":"Poradně","products":"Produktech a&nbsp;kategoriích"}}},"en":{"CatalogContentSwitcher":{"title":"Found in","nav":{"articles":"Articles","faq_questions":"Advisery","products":"Products and&nbsp;categories"}}}}')
  delete Component.options._Ctor
}
